import * as React from 'react';

const CusBbox = (props) => {

    return (

        <div className="row around-xs inputPair elementVisible">
            &nbsp;&nbsp;&nbsp;&nbsp;
            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 bbline3">
                <div id={props.id1} className="box text-left padbox">{props.lb1}:<br />{props.val1}<br /><br /></div>

            </div>&nbsp;&nbsp;&nbsp;
            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 bbline3">
                <div id={props.id2} className="box text-left padbox" >{props.lb2}:<br />{props.val2}<br /><br /></div>

            </div>
        </div>
    )
}

export default CusBbox;